export default {
  WX_BASE_URL : "https://wfu.yqhui.cn/",
  EVENTID: '18c3f88a-b361-6004-3057-6881a4c25154',
  
  TRAFFICID: '18c53995-4226-cfa5-5a43-e1e2b7d34481',
  ENG_TRAFFICID: '18c65366-2475-e3be-7e99-674595ee3f34',

  CONTACTID: '18c53b2a-7223-1a2d-d721-c27efb018d03',
  SCHEDULEID: '18c827b0-51d2-ad97-dad8-831c803c821f',
  SCHEDULESUBID: '18ccd240-92b5-ef70-c497-9e1e6c2c16e0',
 }
